export default "__VITE_ASSET__50b108fd__"